import React, { useEffect, useState } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document";
import Loader from "../../components/shared/Loader";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import userPlaceholder from "../../assets/images/placeholder.jpg";
import { updateMeta } from "../../store/actions/metaAction";

const ServicesCreate = () => {
	const dispatch = useDispatch();
	const history = useHistory();

	const auth = useSelector(state => state.auth.user);

	const [loading, setLoading] = useState(false);
	const [title, setTitle] = useState("");
	// eslint-disable-next-line no-unused-vars
	const [color, setColor] = useState("");
	const [description, setDescription] = useState("");
	const [pageContent, setPageContent] = useState("");
	const [infoTitle, setInfoTitle] = useState("");
	const [informations, setInformations] = useState([]);
	const [pageTitle, setPageTitle] = useState("");
	const [pageUrl, setPageUrl] = useState("");
	const [pageDescrition, setPageDescrition] = useState("");
	const [pageKeyWords, setPageKeyWords] = useState("");
	const [picture, setPicture] = useState(null);
	const [pictureInner, setPictureInner] = useState(null);

	let editor = null;

	useEffect(() => {
		onStart();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const onStart = () => {
		dispatch(
			updateMeta({
				title: "اضافة خدمة جديدة",
				breadcrumb: "الخدمات",
				button: {
					show: false,
					text: null,
					link: null,
				},
			})
		);
	};

	const pushToInformation = e => {
		e.preventDefault();
		if (infoTitle === "") {
			toast.error("برجاء تعبئة الحقول المطلوبة!");
			return;
		}
		const data = { title: infoTitle };
		informations.push(data);
		setInformations(informations);
		setInfoTitle("");
	};

	const handleDeleteInfo = (event, information) => {
		event.preventDefault();
		const arr = informations.filter(function (item) {
			return item.title !== information.title;
		});
		setInformations(arr);
	};
	const handleUploadPicture = e => {
		const file = e.target.files[0];
		const formData = new FormData();
		formData.append("file", file);

		setLoading(true);
		axios
			.post(`${process.env.REACT_APP_API_URL}/upload`, formData, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
					"Content-Type": "multipart/form-data",
				},
			})
			.then(res => {
				setLoading(false);

				setPicture(res.data.data.filePath);
			})
			.catch(err => {
				console.log(err);
				setLoading(false);
			});
	};

	const handleUploadPictureInner = e => {
		const file = e.target.files[0];
		const formData = new FormData();
		formData.append("file", file);

		setLoading(true);
		axios
			.post(`${process.env.REACT_APP_API_URL}/upload`, formData, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
					"Content-Type": "multipart/form-data",
				},
			})
			.then(res => {
				setLoading(false);
				setPictureInner(res.data.data.filePath);
			})
			.catch(err => {
				console.log(err);
				setLoading(false);
			});
	};

	const handleSubmit = e => {
		e.preventDefault();

		setLoading(true);
		if (!picture) {
			toast.error("برجاء اختيار الصورة الرئيسية");
			setLoading(false);
			return;
		} else if (!pictureInner) {
			toast.error("برجاء اختيار الصورة الداخلية");
			setLoading(false);
			return;
		}

		const data = {
			title: title,
			color: color,
			description: description,
			icon: picture,
			picture,
			pictureInner,
			page_content: pageContent,
			informations: informations,
			pageTitle: pageTitle,
			pageUrl: pageUrl,
			pageDescrition: pageDescrition,
			pageKeyWords: pageKeyWords,
		};
		axios
			.post(
				`${process.env.REACT_APP_API_URL}/posts`,
				{
					category_id: 4,
					admin_id: auth.data.id,
					data: data,
				},
				{
					headers: {
						Authorization: `Bearer ${cookie.get("token")}`,
						Accept: "application/json",
					},
				}
			)
			.then(function (response) {
				history.push("/services/index");
				toast.success("تم اضافة الخدمة بنجاح!");
				setLoading(false);
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة مره اخرى!");
				setLoading(false);
			});
	};

	return (
		<section>
			{loading && <Loader />}
			<form onSubmit={handleSubmit}>
				<div className="row">
					<div className="col-md-9">
						<div className="card">
							<div className="card-body">
								<div className="row">
									<div className="col-md-12">
										<div className="form-item">
											<label htmlFor="title">العنوان</label>
											<input
												type="text"
												id="title"
												required
												onChange={e => setTitle(e.target.value)}
											/>
										</div>
									</div>
									{/* <div className="col-md-3">
										<div className="form-item">
											<label htmlFor="color">اللون في الجوال</label>
											<input
												type="color"
												id="color"
												required
												onChange={e => setColor(e.target.value)}
											/>
										</div>
									</div> */}
								</div>
								<div className="form-item">
									<label htmlFor="description">الوصف</label>
									<input
										type="text"
										id="description"
										required
										onChange={e => setDescription(e.target.value)}
									/>
								</div>

								<div className="form-item">
									<label htmlFor="pageContent">النص</label>
									<CKEditor
										onReady={editor => {
											editor.ui
												.getEditableElement()
												.parentElement.insertBefore(
													editor.ui.view.toolbar.element,
													editor.ui.getEditableElement()
												);
											// eslint-disable-next-line no-self-assign
											editor = editor;
										}}
										onError={({ willEditorRestart }) => {
											if (willEditorRestart) {
												editor.ui.view.toolbar.element.remove();
											}
										}}
										onChange={(event, editor) => {
											const data = editor.getData();
											setPageContent(data);
										}}
										editor={DecoupledEditor}
										config={{
											contentsLangDirection: "rtl",
											language: "ar",
											extraPlugins: [MyCustomUploadAdapterPlugin],
										}}
									/>
								</div>
								<hr />
								<div className="form-item">
									<label htmlFor="question">عنوان المعلومة</label>
									<input
										type="text"
										id="question"
										value={infoTitle}
										onChange={e => setInfoTitle(e.target.value)}
									/>
								</div>
								<div className="form-item"></div>
								<button className="bt bt-success" onClick={pushToInformation}>
									اضافة المعلومة
								</button>
								<div className="form-item" style={{ marginTop: "40px" }}>
									<ul className="list-unstyled pointList">
										{informations.map(information => (
											<li key={information.title}>
												<button
													onClick={e => handleDeleteInfo(e, information)}
													type="button"
													aria-label="delete"
												>
													<i className="fas fa-trash"></i>
												</button>
												<span>{information.title}</span>
											</li>
										))}
									</ul>
								</div>
							</div>
						</div>
						<div className="card mt-5">
							<div className="card-header">تفاصيل محركات البحث</div>
							<div className="card-body">
								<div className="form-item">
									<label htmlFor="pageTitle">عنوان الصفحة</label>
									<input
										type="text"
										id="pageTitle"
										required
										onChange={e => setPageTitle(e.target.value)}
									/>
								</div>
								<div className="form-item">
									<label htmlFor="pageUrl">رابط الصفحة</label>
									<input
										type="text"
										id="pageUrl"
										required
										onChange={e => setPageUrl(e.target.value)}
									/>
								</div>
								<div className="form-item">
									<label htmlFor="pageDescription">وصف الصفحة</label>
									<textarea
										id="pageDescription"
										rows="2"
										onChange={e => setPageDescrition(e.target.value)}
										required
									></textarea>
								</div>
								<div className="form-item">
									<label htmlFor="pageKeyWords">الكلمات المفتاحية</label>
									<textarea
										id="pageKeyWords"
										rows="2"
										onChange={e => setPageKeyWords(e.target.value)}
										required
									></textarea>
								</div>
							</div>
						</div>
					</div>
					<div className="col-md-3">
						<div className="card">
							<div className="card-body">
								<div className="form-item">
									<label htmlFor="picture">ايقونة الخدمة</label>
									<input
										type="file"
										onChange={handleUploadPicture}
										id="picture"
									/>
									<img
										src={picture ? picture : userPlaceholder}
										alt="avatar"
										className="imagePreview"
									/>
								</div>
								<div className="form-item my-4">
									<label htmlFor="pictureInner">الصوره الداخلية للخدمة</label>
									<input
										type="file"
										onChange={handleUploadPictureInner}
										id="pictureInner"
									/>
									<img
										src={pictureInner ? pictureInner : userPlaceholder}
										alt="avatar"
										className="imagePreview"
									/>
								</div>
							</div>
						</div>
						<div className="form-item mt-3">
							<button className="bt bt-success btn-block" type="submit">
								ارسال
							</button>
						</div>
					</div>
				</div>
			</form>
		</section>
	);
};

function MyCustomUploadAdapterPlugin(editor) {
	editor.plugins.get("FileRepository").createUploadAdapter = loader => {
		return new MyUploadAdapter(loader);
	};
}

class MyUploadAdapter {
	constructor(props) {
		this.loader = props;
		this.url = `${process.env.REACT_APP_API_URL}/upload`;
	}

	upload() {
		return new Promise((resolve, reject) => {
			this._initRequest();
			this._initListeners(resolve, reject);
			this._sendRequest();
		});
	}

	abort() {
		if (this.xhr) {
			this.xhr.abort();
		}
	}

	_initRequest() {
		const xhr = (this.xhr = new XMLHttpRequest());

		xhr.open("POST", this.url, true);
		xhr.responseType = "json";
		xhr.setRequestHeader("Authorization", `Bearer ${cookie.get("token")}`);
	}

	_initListeners(resolve, reject) {
		const xhr = this.xhr;
		const loader = this.loader;
		// eslint-disable-next-line no-useless-concat
		const genericErrorText = "Couldn't upload file:" + ` ${loader.file.name}.`;

		xhr.addEventListener("error", () => reject(genericErrorText));
		xhr.addEventListener("abort", () => reject());
		xhr.addEventListener("load", () => {
			const response = xhr.response;
			if (!response || response.error) {
				return reject(
					response && response.error ? response.error.message : genericErrorText
				);
			}
			resolve({
				default: response.data.filePath,
			});
		});

		if (xhr.upload) {
			xhr.upload.addEventListener("progress", evt => {
				if (evt.lengthComputable) {
					loader.uploadTotal = evt.total;
					loader.uploaded = evt.loaded;
				}
			});
		}
	}

	_sendRequest() {
		const data = new FormData();
		this.loader.file.then(result => {
			data.append("file", result);
			this.xhr.send(data);
		});
	}
}

export default ServicesCreate;
